import Axios from 'axios';

export const mislecAPI = Axios.create({
    baseURL: process.env.REACT_APP_API,
    timeout: 420000,
    headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: 'Bearer ' + sessionStorage.getItem('mISLec_access_token') || ''
    },
});